// @ts-strict-ignore
/**
 * @owner @Appboy/reporting
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/content_cards_credit_consumption_detail_data" endpoint
 */
import { isContentCardsConsumptionResult } from "@dashboardApi/apis/contentCardsConsumption/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { contentCardsConsumption } from "./constants";
import type { ContentCardsConsumptionParams, ContentCardsConsumptionResult } from "./types";

export const getDataTableContentCardsConsumption = reactQueryTableFetcherAdapter(
  contentCardsConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, sortby, sortdir, start = 0 }: ContentCardsConsumptionParams
  ): Promise<ContentCardsConsumptionResult> => {
    const { start_date, end_date, app_group: appGroup, card_type: cardType } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/content_cards_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(appGroup && { app_group: appGroup }),
          ...(cardType && { card_type: cardType }),
        }),
      },
      { signal }
    );
  },
  isContentCardsConsumptionResult
);
